module.exports = __webpack_public_path__ + "flag_united_kingdom.svg?52206ee59c9d848639319f81a7261da9";


//////////////////
// WEBPACK FOOTER
// ./assets/flags/flag_united_kingdom.svg
// module id = 538
// module chunks = 0